import {
  getCompetencySettingsApi,
  setCompetencySettingsApi,
  getFunctionListApi,
  getCompetencySummaryApi,
  getCompetencyDescriptionApi,
  updateCompetencyDescriptionApi,
  saveCompetencyApi,
  disableCompetencyRowApi,
  enableCompetencyRowApi,
} from 'api/competencies';
import HashTag from 'models/hashtag';

import { pickFromObject } from 'constants/helper';

import { getOrganizationTagObjectFromRes } from './helpers/admin';

export const getCompetencySettings = () => getCompetencySettingsApi().then((res) => res.entity);

export const setCompetencySettings = ({ viewType }) => setCompetencySettingsApi({ viewType }).then((res) => res.entity);

export const getFunctionList = () => getFunctionListApi().then((res) => res.entity);

export const getCompetencySummary = (functionId) => {
  const funcId = functionId ?? undefined;
  return getCompetencySummaryApi({ functionId: funcId }).then((res) => res.entity);
};

export const getCompetencyDescription = ({ functionId, competencyId }) =>
  getCompetencyDescriptionApi({ functionId, competencyId }).then((res) => {
    const { description, organizationTag } = res.entity;
    const hashtag = new HashTag();
    hashtag.fromJSON(organizationTag);

    const isEntireRowDisabled = !description.map((desc) => desc.isDisabled).includes(false);

    const descriptionMap = description ? description.reduce((a, v) => ({ ...a, [v.jobRoleId]: v }), {}) : {};
    return {
      description: descriptionMap,
      organizationTag: { ...hashtag, isEntireRowDisabled },
    };
  });

export const updateCompetencyDescription = ({ description, competencyId, functionId }) =>
  updateCompetencyDescriptionApi({ description, competencyId, functionId }).then((res) => res.entity);

export const saveCompetency = (
  orgTag,
  teamId,
  tagType = 'MESH_TASK',
  fieldsRequired = ['name', 'displayName', 'active', 'description'],
  parentTagId
) => {
  const organizationTag = {
    team: teamId
      ? {
          uuid: teamId,
        }
      : null,
    parentTag: parentTagId ? { uuid: parentTagId } : null,
    tagType,
    ...pickFromObject(orgTag, fieldsRequired),
  };
  return saveCompetencyApi({
    orgTag: organizationTag,
    jobFunctionRole: orgTag.jobFunctionRole,
  }).then((res) => getOrganizationTagObjectFromRes(res.entity?.organizationTag));
};

export const disableCompetencyRow = ({ functionId, competencyId }) =>
  disableCompetencyRowApi({ functionId, competencyId }).then((res) => res.entity);

export const enableCompetencyRow = ({ functionId, competencyId }) =>
  enableCompetencyRowApi({ functionId, competencyId }).then((res) => res.entity);
